import { render, staticRenderFns } from "./index_view.vue?vue&type=template&id=1a8a2e6c&"
import script from "./index_view.vue?vue&type=script&lang=js&"
export * from "./index_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports